import { NgModule, ModuleWithProviders } from '@angular/core';
import { VernostService } from '../services/app.service';
// import { VernostTableComponent } from '../vernost-table-list/vernost.table.component';
import {
    MatButtonModule,
    MatMenuModule,
    MatToolbarModule,
    MatIconModule,
    MatCardModule,
    MatInputModule, MatPaginatorModule, MatProgressSpinnerModule, MatSortModule, MatTableModule
} from '@angular/material';

import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
// import { AutoCompleteModule } from 'primeng/autocomplete';
import { ModelInputComponent } from "../components/model-input/model-input.component";
import { TinyEditorComponent } from "../components/tiny-editor/tiny-editor.component";
import { VernostSearchComponent } from "../components/vernost-search/vernost-search";
import { VernostScreenComponent } from "../components/vernost-screen/vernost-screen";
import { VernostListComponent } from "../components/vernost-list/vernost-list";
import { VernostTableComponent } from "../components/vernost-list/vernost-table";
import { VernostTableRowComponent } from "../components/vernost-list/vernost-table.row";
import {MatFormFieldModule} from '@angular/material/form-field';
// import { HttpModule } from "@angular/http";
import { HttpClientModule } from '@angular/common/http';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import { VernostProgressBarComponent } from "../components/vernost-progressbar/vernost-progressbar";
import { VernostSpinnerComponent } from "../components/vernost-spinner/vernost-spinner";
import { AngularDateTimePickerModule } from "../components/daterange/datepicker.module";
import { AngularMultiSelectModule } from "../components/multiselection/multiselect.component";
import { CuppaDataGridModule } from "../components/vernost-data-grid/angular-dataGrid";
// import { MatAutocompleteModule } from "../vernost-table-list/material/autocomplete"
// import { MatTableModule, MatPaginatorModule,MatSortModule,MatInputModule,MatProgressSpinnerModule } from "../vernost-list-table/material";
// import { VernostListTableComponent } from "../vernost-table-list/table-overview-example"
import { DropdownOpen } from "../toggle/DropdownOpen";
import { Dropdown } from "../toggle/dropdown.directive";
import { DropdownNotClosableZone } from "../toggle/DropdownNotClosableZone";
@NgModule({
    declarations: [
        DropdownNotClosableZone,
        Dropdown,
        DropdownOpen,
        // Pipes.
        // Directives.
        // Components.
        VernostTableComponent,
        ModelInputComponent,
        TinyEditorComponent,
        VernostSearchComponent,
        VernostScreenComponent,
        VernostListComponent,
        VernostTableRowComponent,
        VernostProgressBarComponent,
        VernostSpinnerComponent,
        // VernostListTableComponent,
    ],
    exports: [
        DropdownNotClosableZone,
        Dropdown,
        DropdownOpen,
        // Pipes.
        // Directives.
        // Components.
        // AutoCompleteModule,
        AngularDateTimePickerModule,
        AngularMultiSelectModule,
        CuppaDataGridModule,
        ModelInputComponent,
        TinyEditorComponent,
        VernostSearchComponent,
        VernostScreenComponent,
        VernostListComponent,
        VernostTableComponent,
        VernostTableRowComponent,
        VernostProgressBarComponent,
        VernostSpinnerComponent,
        // MatButtonModule,
        // MatMenuModule,
        // MatToolbarModule,
        // MatIconModule,
        // MatCardModule,
        // VernostService,
        //MatInputModule, MatPaginatorModule, MatProgressSpinnerModule, MatSortModule, MatTableModule
        // MatAutocompleteModule
        // VernostListTableComponent
    ],
    imports: [
        // AutoCompleteModule,
        MatButtonModule,
        MatMenuModule,
        MatToolbarModule,
        MatIconModule,
        MatCardModule,
        HttpClientModule,
        MatInputModule, MatPaginatorModule, MatProgressSpinnerModule, MatSortModule, MatTableModule,
        CommonModule,
        FormsModule,
        MatProgressBarModule,
        MatSnackBarModule,
        MatFormFieldModule,
        ReactiveFormsModule,
        AngularDateTimePickerModule,
        AngularMultiSelectModule,
        CuppaDataGridModule,
        // MatAutocompleteModule
        //MatTableModule, MatPaginatorModule,MatSortModule,MatInputModule,MatProgressSpinnerModule
    ],
    providers:[VernostService]

})
// Consider registering providers using a forRoot() method
// when the module exports components, directives or pipes that require sharing the same providers instances.
// Consider registering providers also using a forChild() method
// when they requires new providers instances or different providers in child modules.
export class VernostLibModule {

    /**
     * Use in AppModule: new instance of SumService.
     */
    public static forRoot(): ModuleWithProviders {
        return {
            ngModule: VernostLibModule,
            providers: [VernostService]
        };
    }

    /**
     * Use in features modules with lazy loading: new instance of SumService.
     */
    public static forChild(): ModuleWithProviders {
        return {
            ngModule: VernostLibModule,
            providers: [VernostService]
        };
    }

}
